<template>
    <div>
        <div class="row my-3">
            <div class="col-lg-3">
                <select name="cat-filter" id="cat-filter" class="form-control px-3 border-dark" v-model="catSelected">
                    <option value="">Seleccione una categoría</option>
                    <optgroup v-for="(cat, index) of categories.children" :key="index" :label="cat.name">
                        <option v-for="(catc, i) of cat.children" :key="'child' + i" :value="catc.term_id">
                            {{ catc.name }}
                        </option>
                    </optgroup>
                </select>
            </div>
            <div class="col-lg-3">
                <input type="text" name="name-filter" v-model="courseName" id="name-filter"
                    class="form-control px-3 border-dark" placeholder="Nombre del curso" />
            </div>
            <div class="col-lg-3">
                <select name="tipo-curso-filter" id="tipo-curso-filter" class="form-control px-3 border-dark"
                    v-model="tipoCursoSelected">
                    <option value="default">Cursos Utel</option>
                    <option value="propios">Cursos Propios</option>
                </select>
            </div>
            <div class="col-lg-3">
                <button class="btn btn-utel w-100" @click="filterDataCourse">
                    Filtrar cursos
                </button>
            </div>
        </div>

        <div class="d-flex justify-content-center" v-if="mostrarPaginasCourses" style="margin-bottom: 10px">
            <div style="display:inline-block" v-if="paginaActualCourses - 2 > 0">
                <button class="btn btn-utelx" @click.prevent="getCoursesByPage(1)"><i class="fa-solid fa-angles-left"></i></button>
            </div>
            <div style="display:inline-block; margin-left: 10px" v-if="paginaActualCourses > 1">
                <button class="btn btn-utelx" @click.prevent="getCoursesByPage(paginaActualCourses-1)"><i class="fa-solid fa-angle-left"></i></button>
            </div>
            <div style="display:inline-block; margin-left: 10px">
                <button class="btn btn-primary" @click.prevent="getCoursesByPage(paginaActualCourses)">{{ paginaActualCourses }}</button>
            </div>
            <div style="display:inline-block; margin-left: 10px" v-if="ultimaPaginaCourses == -1 || paginaActualCourses < ultimaPaginaCourses">
                <button class="btn btn-utelx" @click.prevent="getCoursesByPage(paginaActualCourses+1)"><i class="fa-solid fa-angle-right"></i></button>
            </div>
            <div style="display:inline-block; margin-left: 10px" v-if="ultimaPaginaCourses != -1 && ultimaPaginaCourses >= paginaActualCourses + 2">
                <button class="btn btn-utelx" @click.prevent="getCoursesByPage(ultimaPaginaCourses)"><i class="fa-solid fa-angles-right"></i></button>
            </div>
        </div>

        <div class="row">
            <div v-for="(course, index) in dessertsCourse" :key="index" class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-3">
                <div class="card rounded-8 text-dark overflow-hidden">
                    <img :src="course.image" alt="" style="height: 90px; object-fit: cover; " />

                    <div class="card-body small">
                        <h6 class="card-title small" style="height: 40px;">
                            {{ course.name }}
                        </h6>
                        <p class="card-text small">{{ strippedContent(course.content).length>=150 ? strippedContent(course.content).substring(0,150)+"..." : strippedContent(course.content) }}</p>
                        <button type="button" class="btn btn-primary w-75 text-light m-auto d-block"
                            data-bs-toggle="modal" data-bs-target="#addModal" @click="openModalCourse(course)">
                            Agregar curso
                        </button>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center" v-if="mostrarPaginasCourses" style="margin-bottom: 10px">
                <div style="display:inline-block" v-if="paginaActualCourses - 2 > 0">
                    <button class="btn btn-utelx" @click.prevent="getCoursesByPage(1)"><i class="fa-solid fa-angles-left"></i></button>
                </div>
                <div style="display:inline-block; margin-left: 10px" v-if="paginaActualCourses > 1">
                    <button class="btn btn-utelx" @click.prevent="getCoursesByPage(paginaActualCourses-1)"><i class="fa-solid fa-angle-left"></i></button>
                </div>
                <div style="display:inline-block; margin-left: 10px">
                    <button class="btn btn-primary" @click.prevent="getCoursesByPage(paginaActualCourses)">{{ paginaActualCourses }}</button>
                </div>
                <div style="display:inline-block; margin-left: 10px" v-if="ultimaPaginaCourses == -1 || paginaActualCourses < ultimaPaginaCourses">
                    <button class="btn btn-utelx" @click.prevent="getCoursesByPage(paginaActualCourses+1)"><i class="fa-solid fa-angle-right"></i></button>
                </div>
                <div style="display:inline-block; margin-left: 10px" v-if="ultimaPaginaCourses != -1 && ultimaPaginaCourses >= paginaActualCourses + 2">
                    <button class="btn btn-utelx" @click.prevent="getCoursesByPage(ultimaPaginaCourses)"><i class="fa-solid fa-angles-right"></i></button>
                </div>
            </div>
        </div>

        <!-- modal selection -->
        <div class="modal fade" id="addModal" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="addModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header text-center bg-primary text-light py-2">
                        <h5 class="modal-title">
                            Agregar curso
                        </h5>
                        <button type="button" class="btn-close text-light" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center pb-4">
                        <!-- Sección listado Cursos INICIO -->
                        <div id="listadoCursosPaquetes" class="d-none mb-4">
                            <div v-if="listcourses" class="mb-3" id="ocultarData">
                                <div class="alert alert-primary small">
                                    <b>Atención: </b>
                                    Para poder continuar, debes agregar estos cursos.
                                </div>
                                <div class="px-3" style="max-height: 300px; overflow-y: scroll;">
                                    <div class="course border-bottom border-gray row align-items-center my-2"
                                    v-for="(item, index) in listcourses" :index="index" :key="item.test">
                                        <div class="col-1">
                                            <div class="course-id">
                                                {{ index + 1 }}
                                            </div>
                                        </div>
                                        <div class="col-4 py-1">
                                            <img :src="item.image" alt="" class="img-fluid rounded-3">
                                        </div>
                                        <div class="col-7 py-1">
                                            <div class="course-description lh-1 text-start">
                                                {{ item.name }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <h3>¿Deseas continuar?</h3>
                                    <div class="">
                                        <button v-on:click="seen_two = !seen_two" id="yes_button" type="button"
                                        class="btn btn-utel btn-inverted me-3" @click="agregar_cursos_extra()">
                                            Si
                                        </button>
                                        <button  @click="cancelarProceso()" id="no_button" type="button" class="btn btn-utel text-light px-4" data-bs-dismiss="modal">
                                            No
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Sección listado Cursos FIN -->
                        <!-- Sección listado Empresa INICIO -->
                        <div v-if="seen" class="d-flex gap-2 align-items-center">
                            <label for="period-filter" class="col-auto p-0 m-0">Seleccione una empresa: </label>
                            <select @change="seleccionCliente($event)" name="company-filter" id="period-filter" v-model="routeCompany"
                                class="form-control">
                                <option v-for="c of allCompanies" :key="c.id" :value="c.id">
                                    {{ c.name }}
                                </option>
                            </select>
                        </div>
                        <!-- Sección listado Empresa FIN -->
                        <div class="d-flex gap-2 align-items-center d-none mt-3" id="listRoutes">
                            <label for="period-filter" class="col-auto p-0 m-0">Seleccione una ruta: </label>
                            <select @change="revisarCursosExtra()" name="company-filter" id="period-filter" v-model="routeCompany"
                                class="form-control">
                                <option v-for="r of allRoutes" :key="r.id" :value="r.id">
                                    {{ r.name }}
                                </option>
                            </select>
                        </div>

                        <div class="d-block" id="cirle-content">
                            <div class="circle-loading"></div>
                        </div>

                        <div id="mostrarBotones" class="d-none">
                            <div class="mb-3">
                                <p class="pb-3 mt-2">Seleccione la opción que desea para agregar este curso:</p>
                            </div>
                            <div class="">
                                <button v-on:click="seen = !seen" id="to-add-route" type="button"
                                    class="btn btn-utel btn-inverted me-3" @click="agregarRuta()">
                                    Agregar a una ruta
                                </button>
                                <button id="to-created-route" type="button" class="btn btn-utel text-light px-4"
                                    @click="crearRuta()">
                                    Crear ruta
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- confirmación -->
        <button id="successBtn" type="button" class="btn btn-primary invisible" data-bs-toggle="modal" data-bs-target="#success">
        </button>
        <div class="modal fade" id="success" tabindex="-1"  data-bs-backdrop="static" data-bs-keyboard="false"
            aria-labelledby="successLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-light">
                        <h5 class="modal-title" id="successLabel">Agregar curso</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-center">
                        Se ha agregado <br> correctamente el curso.
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary text-light" data-bs-dismiss="modal">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["get1", "issuperadmin", "idclientbyadmin","headertab", "wptoken", "url", "urlc", "savedata", 'uuidclient', 'urlclients', 'urlnewroute', 'urlgetpackages', 'getcoursebyid'],

    data() {
        return {
            urlRoutes: this.get1,
            categories: [],
            listcourses: [],
            dessertsCourse: [],
            catSelected: "",
            courseSelected: "",
            parentsCategories: [],
            parentId: 0,
            courseName: "",
            routeCompany: 0,
            seen: false,
            seen_two: false,
            seenCourses: false,
            peticionUsuario: "",
            allRoutes: [],
            allCompanies: [],
            GetCourseById: this.getcoursebyid,
            urlNewData: this.savedata,
            dataUuidClient: this.uuidclient,
            urlNewRoute: this.urlnewroute,
            urlGetPackages: this.urlgetpackages,
            destroy: [],
            viewMessage: true,            
            mostrarPaginasCourses: false,
            paginaActualCourses: 0,
            ultimaPaginaCourses: -1,
            tipoCursoSelected: "default",
        };
    },
    mounted() {
        this.getWordpressCourseCategory();
        this.getWordpressCoursee();
        this.getData();
        this.getDataCourse();
    },
    methods: {
        async openModalCourse(course) {
            var coursesCategories = course.categories;
            const parentsCategories = this.parentsCategories;
            let codeParentId = 0;
            for (var k in coursesCategories){
                if (coursesCategories.hasOwnProperty(k)) {
                    for (var j in coursesCategories[k]){
                        if (coursesCategories[k].hasOwnProperty(j)) {
                            if (j == 'id') {
                                if (parentsCategories.find(u => u == coursesCategories[k][j]) != undefined) {
                                    codeParentId = coursesCategories[k][j];
                                }
                            }
                        }
                    }
                }
            }

            let listCourses = [];
            document.getElementById("listadoCursosPaquetes").classList.remove('d-block');
            document.getElementById("listadoCursosPaquetes").classList.add('d-none');
            this.destroy = course;
            this.seen = false;
            this.seen_two = false;
            this.viewMessage = false;
            this.listcourses = [];
            this.parentId = codeParentId;

            await axios.get(this.urlgetpackages + "?withUsers=true&idCourse=" + this.destroy.id).then((res) => {
                if (res.status === 200) {
                    const data = res.data;
                    const url = this.GetCourseById;
                    if(data == ""){
                        this.seen_two = true;
                        this.viewMessage = false;
                        document.getElementById("cirle-content").classList.remove('d-block');
                        document.getElementById("cirle-content").classList.add('d-none');
                        document.getElementById("mostrarBotones").classList.remove('d-none');
                        document.getElementById("mostrarBotones").classList.add('d-block');
                        return;
                    }
                    this.viewMessage = true;
                    data.forEach(async function (id_data) {
                        await axios.get(url, {
                            params: {
                                search: id_data
                            },
                        }).then((res) => {
                            const dataResp = res.data;
                            listCourses.push({ 'image': dataResp.image, "name": dataResp.name, "item": dataResp.id, 'slug': dataResp.slug, 'parent_id': codeParentId });
                        });
                    });
                }
            });

            if(this.viewMessage){
                document.getElementById("cirle-content").classList.remove('d-block');
                document.getElementById("cirle-content").classList.add('d-none');
                document.getElementById("mostrarBotones").classList.remove('d-none');
                document.getElementById("mostrarBotones").classList.add('d-block');
                this.listcourses = listCourses;
                this.seenCourses = true;
                return;
            }


            localStorage.setItem('cursoDefecto', JSON.stringify(this.destroy));

        },
        getData() {
            axios.get(this.url + "?withUsers=true").then((res) => {
                this.desserts = res.data;
            });
        },
        getDataCourse() {
            axios.get("/search").then((res) => {
                this.dessertsCourse = res.data;
                if (res.data.length > 0) {
                    this.mostrarPaginasCourses = true;
                    this.paginaActualCourses = 1;
                }
            });
        },
        getCoursesByPage(page) {
            axios.get("/search", {
                    params: {
                        search: this.courseName,
                        category: this.catSelected,
                        courseType: this.tipoCursoSelected,
                        page: page
                    },
                }).then((res) => {
                this.dessertsCourse = res.data;
                if (res.data.length > 0) {
                    this.mostrarPaginasCourses = true;
                    this.paginaActualCourses = page;
                }
                if (res.data.length < 50) {
                    this.ultimaPaginaCourses = page;
                }
            });
        },
        filterDataCourse() {
            axios
                .get("/search", {
                    params: {
                        search: this.courseName,
                        category: this.catSelected,
                        courseType: this.tipoCursoSelected,
                    },
                })
                .then((res) => {
                    this.dessertsCourse = res.data;
                    this.ultimaPaginaCourses = -1;
                    if (res.data.length > 0) {
                        this.mostrarPaginasCourses = true;
                        this.paginaActualCourses = 1;
                    }
                    if (res.data.length < 50) {
                        this.ultimaPaginaCourses = 1;
                    }
                });
        },
        getWordpressCoursee() {
            axios
                .get("/search", {
                    params: {
                        search: this.courseName,
                        category: this.catSelected,
                        courseType: this.tipoCursoSelected
                    },
                })
                .then((res) => {
                    this.resultSearch = res.data;
                });
        },
        getWordpressCourseCategory() {
            axios.get("/search/category").then((res) => {
                this.categories = res.data;
                let arrayParent = [];
                var categoriesParent = this.categories.children;
                for (var k in categoriesParent){
                    if (categoriesParent.hasOwnProperty(k)) {
                        arrayParent.push(k);
                    }
                }

                this.parentsCategories = arrayParent;
            });
        },
        editarCliente() {
            let btn = document.getElementById("update");
            let cancel = document.getElementById("cancel");
            let modal = document.getElementById("updateModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .put(this.url + "/" + this.edit.uuid, this.edit)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        eliminarCliente() {
            const response = document.getElementById("response");
            let btn = document.getElementById("delete");
            let cancel = document.getElementById("close");
            let modal = document.getElementById("deleteModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .delete(this.url + "/" + this.destroy.id)
                .then((res) => {
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        btn.textContent = "Eliminar";
                    }, 500);
                })
                .catch((err) => {
                    console.log(err.error);
                    response.outerText = "Error al eliminar datos";
                    cancel.removeAttribute("disabled");
                    btn.setAttribute("style", "display:none");

                    setTimeout(() => {
                        btn.removeAttribute("disabled");
                        btn.removeAttribute("style");
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                        window.location.reload();
                    }, 1000);
                });
        },
        agregarCliente() {
            let btn = document.getElementById("agregar");
            let cancel = document.getElementById("closeAdd");
            let modal = document.getElementById("addModal");
            let bd = document.getElementsByClassName("modal-backdrop");
            cancel.setAttribute("disabled", "disabled");
            btn.setAttribute("disabled", "disabled");
            btn.textContent = "Procesando ...";
            axios
                .post(this.url, { cursos: this.selected })
                .then((res) => {
                    console.log(res);
                    this.newClient = { name: "" };
                    btn.textContent = res.data.message;
                    setTimeout(() => {
                        cancel.removeAttribute("disabled");
                        btn.removeAttribute("disabled");
                        this.getData();
                        modal.removeAttribute("style");
                        document.body.removeChild(bd[0]);
                        document.body.removeAttribute("class");
                        document.body.removeAttribute("style");
                    }, 500);
                })
                .catch((err) => { });
        },
        traerEmpresas(){
            axios.get(this.urlclients + "?withUsers=true").then((res) => {
                this.allCompanies = res.data;
            });
        },
        agregarRuta() {
            this.peticionUsuario = "agregarRuta";
            let btn = document.getElementById("to-add-route");
            let btnButtons = document.getElementById("mostrarBotones");
            let bd = document.getElementsByClassName("modal-backdrop");
            let modal = document.getElementById("addModal");
            btnButtons.classList.remove('d-block');
            btnButtons.classList.add('d-none');

            if(this.issuperadmin){
                this.traerEmpresas();
            }
            else{
                this.seen = false;
                this.seleccionCliente(this.idclientbyadmin, false);
            }

            btn.textContent = "Guardar Ruta";
            btn.setAttribute('saveData', "true");

            if(localStorage.getItem('cursoDefecto')) return;
            localStorage.setItem('cursoDefecto', JSON.stringify(this.destroy));
        },
        crearRuta() {
            this.peticionUsuario = "crearRuta";
            this.revisarCursosExtra();
        },
        agregar_cursos_extra(){

            if(localStorage.getItem('cursoDefecto')){
                localStorage.removeItem('cursoDefecto');
            }

            this.destroy.principal = true;
            this.listcourses.push(this.destroy);
            localStorage.setItem('cursoDefecto', JSON.stringify(this.listcourses));
            document.getElementById("ocultarData").classList.add('d-none');

            if(this.peticionUsuario == "crearRuta"){
                window.location.href = `${this.urlNewRoute}?rutas=true`;
            }

            else if(this.peticionUsuario == "agregarRuta"){
                let btn = document.getElementById("to-add-route");
                let bd = document.getElementsByClassName("modal-backdrop");
                let modal = document.getElementById("addModal");
                let successBtn = document.getElementById("successBtn");
                if (btn.getAttribute('saveData') && btn.getAttribute('saveData') == 'true') {
                    btn.textContent = "Agregar a una ruta";
                    btn.removeAttribute('saveData');
                    axios.post(this.urlNewData, { route: this.routeCompany, parent_id: this.parentId, cursos: JSON.parse(localStorage.getItem('cursoDefecto')) })
                        .then((res) => {
                            document.body.removeChild(bd[0]);
                            modal.removeAttribute("style");
                            document.getElementById("mostrarBotones").classList.remove('d-block');
                            document.getElementById("mostrarBotones").classList.add('d-none');
                            document.getElementById("cirle-content").classList.remove('d-none');
                            document.getElementById("cirle-content").classList.add('d-block');
                            successBtn.click();
                            if(localStorage.getItem('cursoDefecto')){
                                localStorage.removeItem('cursoDefecto');
                            }
                        })
                        .catch((err) => { });

                    return;
                }
            }

        },
        cancelarProceso(){
            if(localStorage.getItem('cursoDefecto')){
                localStorage.removeItem('cursoDefecto');
            }
            document.getElementById("mostrarBotones").classList.remove('d-block');
            document.getElementById("mostrarBotones").classList.add('d-none');
            document.getElementById("cirle-content").classList.remove('d-none');
            document.getElementById("cirle-content").classList.add('d-block');
        },
        revisarCursosExtra(){
                document.getElementById("ocultarData").classList.remove('d-none');
                document.getElementById("ocultarData").classList.add('d-block');
                document.getElementById("listadoCursosPaquetes").classList.remove('d-none');
                document.getElementById("listadoCursosPaquetes").classList.add('d-block');
                document.getElementById("mostrarBotones").classList.add('d-none');
                document.getElementById("listRoutes").classList.remove('d-block');
                document.getElementById("listRoutes").classList.add('d-none');
                this.seen = false;
        },
        seleccionCliente(val, isSelect = true){
            let value = val;

            if(isSelect) {
                value = val.target.value;
            }

            axios.get(`${this.urlRoutes}?withUsers=true&idClient=${value}`).then((res) => {
                this.allRoutes = res.data;
                document.getElementById("listRoutes").classList.remove('d-none');
                document.getElementById("listRoutes").classList.add('d-block');
            });
        },
        strippedContent(text) {
            let regex = /(<([^>]+)>)/ig;
            return text.replace(regex, "");
        }
    },
};
</script>

<style>
.col-lg-20 {
    flex: 0 0 20%;
    width: 20%;
}

.btn-utelx {
    background-color: white;
    border-color: #4000BC;
    color: #4000BC !important;
}
</style>
